import type { Snippet, SnippetsClientInterface } from './snippetsClient.types';
import BaseClient, { type ExtendedAxiosRequestConfig } from '../BaseClient';
import type { QueryParams } from '~/services/api';
import type { AxiosPromise } from 'axios';

export default class GroupSnippetsClient extends BaseClient implements SnippetsClientInterface {
    constructor(private teamId: number, private groupId: string) {
        super();
    }

    getSnippets(params?: QueryParams, config?: ExtendedAxiosRequestConfig) {
        const url = `/api/v3/teams/${this.teamId}/groups/${this.groupId}/snippets`;
        return this.makeCoreApiRequest(url, 'get', null, params, config);
    }

    getSnippetsCount(params?: QueryParams) {
        const url = `/api/v3/teams/${this.teamId}/groups/${this.groupId}/snippets/count`;
        return this.makeCoreApiRequest(url, 'get', null, params);
    }

    createSnippet(data: Snippet) {
        const url = `/api/v3/teams/${this.teamId}/groups/${this.groupId}/snippets`;
        return this.makeCoreApiRequest(url, 'post', data);
    }

    updateSnippet(snippetId: number, data: Snippet) {
        const url = `/api/v3/teams/${this.teamId}/groups/${this.groupId}/snippets/${snippetId}`;
        return this.makeCoreApiRequest(url, 'put', data);
    }

    deleteSnippet(snippetId: number) {
        const url = `/api/v3/teams/${this.teamId}/groups/${this.groupId}/snippets/${snippetId}`;
        return this.makeCoreApiRequest(url, 'delete');
    }

    getSnippet(_snippetId: number): AxiosPromise<Snippet> {
        throw new Error('Not implemented');
    }

    getSnippetsGroupCounts(_params?: QueryParams): AxiosPromise<{ counts: number }> {
        throw new Error('Not implemented');
    }
}
